import { hasStoredConsent } from "@/lib/consent-context";
import { regionFromPathname } from "@/lib/region";

type GtmProps = Record<string, string | number | boolean | undefined | null>;

export function gtmSetRegion(): void {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "region_set",
    region: regionFromPathname(window.location.pathname),
  });
}

export function metaLead(): void {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  if (!hasStoredConsent("marketing")) return;
  window.fbq("track", "Lead");
}

export function gtmEvent(event: string, props?: GtmProps): void {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  const payload: Record<string, unknown> = {
    event,
    region: regionFromPathname(window.location.pathname),
  };
  if (props) {
    for (const [key, value] of Object.entries(props)) {
      if (value !== undefined && value !== null && value !== "") {
        payload[key] = value;
      }
    }
  }
  window.dataLayer.push(payload);
}
